<h1 mat-dialog-title>Consulta ya existente</h1>
<div mat-dialog-content class="dialog-container">
  <div class="dialog-content">
    <p>ya existe un numero de aviso para esta consulta, el numero es: {{ data.aviso.NumAviso }}</p>
    <p>¿Desea continuar o salir?</p>
  </div>
  <div class="dialog-actions">
    <button mat-button (click)="onExit()">Salir</button>
    <button mat-button (click)="onContinue()">Continuar</button>
  </div>
</div>
